import React, { useState, useEffect, useRef } from 'react'
import { fetchTaskList, totalTaskCount } from '../../Components/action/common'
import CompletedAndTrashList from './CompletedAndTrashList'
import { useDispatch, useSelector } from 'react-redux'
import { setTotalCount, setTrashTaskList } from '../../redux/slices/TaskSlice'
import moment from 'moment'
import AllLoader from '../../Components/SkeletonLoading/AllLoader'

function Trash() {
  // global state
  const { trashTaskList } = useSelector(state => state.task)
  const {theme} = useSelector(state => state.theme)
  const currentTimes = moment().startOf('date')
  const [currentTime, setCurrentTime] = useState(new Date(currentTimes));
  const [isLoader, setIsLoader] = useState(false)
  const wrapperRef = useRef(null)

  // dispatch
  const dispatch = useDispatch()

  const fetchAddTaskData = async (type) => {
    if(type == undefined){
      setIsLoader(true);
    }

    try {
      let response = await fetchTaskList({ "isDeleted": 1 })
      setIsLoader(false)
      dispatch(setTrashTaskList(response?.data?.responseData))
      fetchTotalCount()
    } catch ({ response }) {
      setIsLoader(false)
    }
  }

  const fetchTotalCount = async () => {
    try {
      let response = await totalTaskCount({ "date": currentTime.toISOString() })
      dispatch(setTotalCount(response?.data?.responseData))
    } catch ({ response }) {

    }
  }

  useEffect(() => {
    fetchAddTaskData()
    fetchTotalCount()
  }, [])
  
  // useEffect(() => {
  //   if(isLoader) return;

  //   const bound = wrapperRef.current.getBoundingClientRect()
  //   wrapperRef.current.style.height = window.innerHeight - bound.top + 'px'
  // }, [isLoader])

  return (
    <>
      {
        isLoader ? <AllLoader /> : <>
          <div id="tasks-list-wrapper" ref={wrapperRef} className="overdue-form task-list-page rounded-t-[25px] bg-white dark:relative dark:darkmode-background dark:darkmode-blur-before !h-[100vh]">
            <div className="task-list"> 
              <div className="task-list-data h-full">
                <div className="ul-task-list h-full">
                  <div className="task-list task-list-completed">
                    <div className="task-list-data">
                      <ul className="">
                        <CompletedAndTrashList
                          list={trashTaskList}
                          // trash={true}
                          currentPage="trash"
                          fetchAddTaskData={fetchAddTaskData}
                        />
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>

      }

    </>
  )
}

export default Trash